import { render, staticRenderFns } from "./periodi.vue?vue&type=template&id=f8f45994"
import script from "./periodi.vue?vue&type=script&lang=js"
export * from "./periodi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports